<template>
    <main id="hostory-point-wrapper">
        <div id="hostory-point-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url: app_url+'/hcid', status: true },
                    { title: 'Tukar Poin', url: app_url+'/tukar-poin', status: false },
                    { title: 'Histori Redeem', url: app_url+'/history-point', status: true }
                ]"
            ></breadcrumb>
            <div class="container-fluid title-row">
                <div class="container">
                    <div class="row">
                        <div class="col align-self-center">
                            <h2 class="title">Histori Redeem</h2>
                        </div>
                        <div class="col-md-4 text-center py-3">
                            <div class="row">
                                <div class="col">
                                    <span>Poin Saya</span>
                                </div>
                            </div>
                            <div class="row py-2">
                                <div class="col">
                                    <div class="boxcoin">
                                    <span class="coin"></span>
                                    <h2 class="d-inline-flex" id="poin-amount">{{currentPoint}}</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <a @click="redeemPointTracker" :href="app_url+'/tukar-poin'" class="btn btn-redeem">Redeem Sekarang</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div v-if="loaderpoint" class="loading loading-double"></div>
                    <div v-else class="col-md-12">
                        <div  v-if="points.length > 0" class="row pb-3">
                            <div class="col">
                                <div class="card my-4" v-for="(point, i) in points" :key="i">
                                    <div class="card-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-1 col-left flex-center">
                                                <span class="coin"><span class="poin-value">{{point.point}}</span></span>
                                                <span class="poin-text">Point</span>
                                            </div>
                                            <div class="col">
                                                <span class="date-content">{{point.date}}</span>
                                                <h3 class="title-content">{{point.title}}</h3>
                                                <div class="row" v-if="point.done">
                                                    <img :src="base_url+'/images/check.png'" alt="img-check" class="img-check ">
                                                    <div class="col">
                                                        <span>{{point.status_str}}</span>
                                                    </div>
                                                </div>
                                                <div class="row" v-else>
                                                    <img :src="base_url+'/images/check-grey.png'" alt="img-check" class="img-check ">
                                                    <div class="col">
                                                        <span>{{point.status_str}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="messagebox">
                                <h4>Belum ada transaksi poin</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";

export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            points:[],
            loaderpoint:true,
            currentPoint:0,
            mobile: false,
            user:null,
            currentPoint:0,
            endpoint:api_url+'/member/history-redeem',
            endpointhistory:api_url+'/member/point?limit=5&type=tambah',
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
            this.getPoint();
            this.getPointUser();
        }else{
            window.location.href = app_url+'/login';
        }
    },
    methods: {
        redeemPointTracker() {
            const track = {
                'event': 'redeemPoint',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Redeem Point Click',
                'eventDetail.label': 'Profile HCID'
            }
            dataLayer.push(track);
        },
        getPoint() {
                this.loaderpoint = true;
                var token = localStorage.getItem('token') ;
                axios.get(this.endpoint,{
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                    .then(response => {
                        this.points = response.data.data.redeem;
                        this.loaderpoint = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getPointUser() {
                this.loaderpoint = true;
                var token = localStorage.getItem('token') ;
                axios.get(api_url+'/member/point?limit=5&type=tambah',{
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.currentPoint = response.data.point
                        this.loaderpoint = false;
                    }).catch(error => {
                        console.log(error);
                          window.location.href = app_url+'/login';
                    });
        },
    }
};
</script>

<style scoped lang="scss">
.flex-center{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
#hostory-point-page{
    background: #000000;
    .card{
        background: #191919;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .title-row{
        background: #191919;
        opacity: 0.95;
        color: #FFFFFF;
    }
    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
    }
    .poin-head{
        max-height: 43px;
    }
    .img-poin{
        max-height: 50px;
    }
    #poin-amount{
        vertical-align: sub;
    }
    .btn-redeem{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .poin-value{
        left: -5px;
        top: 2px;
        position: absolute;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 25px;
        text-align: center;
        color: #000000;
        z-index: 100;
        width: 40px;
        height: 40px;
        font-size: 12px;
    }
    .title-content{
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
    }
    .date-content{
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
        color: #B4B4B4;
    }
    .poin-text{
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
    }
    .img-check{
        max-height: 19px;
        padding-left: 15px;
    }
    @media (max-width: 768px) {
    .col-left{
        width:auto;
    }
    .poin-head{
        max-height: 33px;
    }
    .poin-value{
        left: 22px;
    }
    .title{
        text-align: center;
        padding-top: 2rem !important;
    }
    }
}
</style>
